import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { TdLoadingService } from '@covalent/core';
import { LoginService } from '../../services/';

import { Profesional } from '../../models/';

@Component({
  selector: 'qs-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent {

  routes: Object[] = [{
    title: 'Hoja de consulta',
    route: '/main',
    icon: 'calendar',
  }, {
    title: 'Perfil',
    route: '/main/perfil',
    icon: 'user',
  },
  ];

  public profesional: any;

  constructor(private _router: Router, private _loadingService: TdLoadingService, private _loginService: LoginService) {
      this.profesional = this._loginService.profesional;
  }

  logout(): void {
    this._loadingService.register();
    this._loadingService.resolve();
    this._loginService.logout();
    this._router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/main.component.ts